import React from "react";
import logoicn from "../../../assets/images/triton-rei-group-logo.svg";
const LogoIcon = () => {
  return <img alt="Logo" src={logoicn} />;
};

export default LogoIcon;
